import React from 'react';

import { IBenefit } from 'shared/domain/entities';
import { Trans, useLocale } from 'shared/presentation/contexts';
import { useCurrencyFormatter } from 'shared/presentation/hooks';

import * as S from './styles';

interface IInstallmentDiscountContentProps {
  title?: boolean;
  benefit: IBenefit;
}

const InstallmentDiscountContent: React.FC<
  IInstallmentDiscountContentProps
> = ({ benefit, title = true }) => {
  const { t } = useLocale('shared');
  const formatter = useCurrencyFormatter();

  return (
    <S.Container>
      {title && (
        <h1>
          <Trans
            t={t}
            localeKey="At Vialaser your recommendation means a looooot! <1>Up to {{value}} in discounts</1> of your installments <3>Enjoy!</3>"
          >
            {'At Vialaser your recommendation means a looooot!  '}
            <strong>
              {'Up to '}
              {{
                value: formatter.format(benefit.recommendation.discount.value),
              }}
              {' in discounts'}
            </strong>
            {' of your installments '}
            <strong>Enjoy!</strong>
          </Trans>
        </h1>
      )}

      <p>
        <Trans
          t={t}
          localeKey="You can send your personalized link to as many friends as you want <1>The more you indicate, the easier it is to win</1> For each friend who purchases a package over {{minimumBudgetValue}} you receive a <5>discount of {{value}} on your next installment</5> Your referrals <7>also receive a {{discount}} discount</7> to keep their waxing up to date"
        >
          {
            'You can send your personalized link to as many friends as you want '
          }
          <strong>The more you indicate, the easier it is to win</strong>
          {' For each friend who purchases a package over '}
          {{ minimumBudgetValue: formatter.format(benefit.minimumBudgetValue) }}
          {' you receive a '}
          <strong>
            {'discount of  '}
            {{ value: formatter.format(benefit.recommendation.discount.value) }}
            {' on your next installment'}.
          </strong>
          {' Your referrals '}
          <strong>
            also receive a{' '}
            {{
              discount: formatter.format(
                benefit.recommendation.givenCoupon.value,
              ),
            }}{' '}
            discount
          </strong>
          {' to keep their waxing up to date'}
        </Trans>
      </p>
    </S.Container>
  );
};

export default InstallmentDiscountContent;
